import {Injectable} from '@angular/core';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
import {environment} from '../../environments/environment';

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {


  constructor(private $gaService: GoogleAnalyticsService) {
  }

  initialize() {
    if (!environment.googleAnalyticsID) {
      return;
    }

    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s) as HTMLScriptElement,
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtag/js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', environment.googleAnalyticsID);
  }
}
